import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Suspense, useMemo } from "react";
import { appRoutesConfig, appGlobalRoutes } from "@pages/appRoutesConfig";
import { useAppSelector } from "@redux";
import { pageRoutes } from "@pages";
import { TopBarProgressbar } from "@components/topPropgressBar";
import { Helmet } from "react-helmet";
import { Breadcrumbs } from "./_breadCrumb";
import { PERMISSIONS } from "@config/permissions";

export const AppRouter = () => {
  const { actions } = useAppSelector((S) => S.permission);

  const handleStartRoute = useMemo(() => {
    switch (true) {
      case actions.includes(PERMISSIONS.COCKPIT_CREW_LIST):
        return pageRoutes.Cockpits;
      case actions.includes(PERMISSIONS.CABIN_CREW_LIST):
        return pageRoutes.Cabins;
      case actions.includes(PERMISSIONS.DOCUMENT_TEMPLATE_LIST):
        return pageRoutes.Documents;
      default:
        return pageRoutes.ER403;
    }
  }, [actions]);

  return (
    <Suspense fallback={<TopBarProgressbar />}>
      <BrowserRouter>
        <Switch>
          {appRoutesConfig.map((L, li: number) => {
            const hasLayoutAccess = L.auth.every((P) => actions.includes(P));
            if (hasLayoutAccess)
              return L.routes.map((R, ri: number) => {
                const hasPageAccess = R.auth.every((P) => actions.includes(P));
                if (hasPageAccess)
                  return (
                    <Route key={R.title} path={R.path} exact={R.exact}>
                      <L.layout>
                        <Helmet>
                          {R?.description && (
                            <meta name="description" content={R.description} />
                          )}
                          {R?.title && <title>{R.title}</title>}
                        </Helmet>
                        <R.component />
                      </L.layout>
                    </Route>
                  );
                else
                  return (
                    <Route path={R.path} exact={R.exact}>
                      <Redirect to={pageRoutes.ER403} />
                    </Route>
                  );
              });
            else
              return (
                <Route path={L.path} exact={false}>
                  <Redirect to={pageRoutes.ER403} />
                </Route>
              );
          })}
          {appGlobalRoutes.map((G) => {
            return (
              <Route path={G.path} key={G.title} exact={G.exact}>
                <Helmet>
                  {G?.description && (
                    <meta name="description" content={G.description} />
                  )}
                  {G?.title && <title>{G.title}</title>}
                </Helmet>
                <G.component />
              </Route>
            );
          })}
          <Redirect exact from={"/"} to={handleStartRoute} />
          <Route>
            <Redirect to={pageRoutes.ER404} />
          </Route>
        </Switch>
        <Breadcrumbs />
      </BrowserRouter>
    </Suspense>
  );
};
